import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import PatientProfile from "./components/PatientProfile/PatientProfile";
import PatientTranscript from "./components/PatientTranscript/PatientTranscript";
import useTitanApp from "../../../../hooks/useTitanApp";
import { motion } from "framer-motion";
import {
  setFirstPatientPanelTitle,
  setTogglePatientPanelOne,
} from "../../../../dispatchers/patientDispatchers";
import { LuChevronLeft, LuPanelLeftOpen } from "react-icons/lu";

export default function PatientProfileTranscript() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const {
    togglePatientPanelOne,
    togglePatientPanelTwo,
    firstPatientPanelTitle,
  } = patientState || {};
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    if (value !== newValue) {
      setValue(newValue);
    }
  };

  // Collapsing hands this panel's width to the template section; the rail reads the title.
  const handleCollapse = () => {
    setFirstPatientPanelTitle(value === 1 ? "Transcript" : "Profile");
    setTogglePatientPanelOne(true);
  };

  return (
    <motion.div
      className="pc-sections"
      animate={{
        width: togglePatientPanelOne
          ? "3%"
          : togglePatientPanelTwo
          ? "48.5%"
          : "33.33%",
      }}
      transition={{ duration: 0.5, type: "spring", stiffness: "60" }}
    >
      {togglePatientPanelOne && (
        <motion.div
          className="collapsed-wrapper"
          key="collapsed-one"
          initial={{ x: 30, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 30, opacity: 0 }}
          transition={{
            duration: 0.4,
            delay: 0.8,
            type: "spring",
            stiffness: "100",
          }}
        >
          <LuPanelLeftOpen
            className="collapse-icon"
            color={darkMode ? "#fff" : "#0a0a0a"}
            onClick={() => setTogglePatientPanelOne(false)}
          />

          <p
            className="collapsed-title"
            style={{
              marginTop: firstPatientPanelTitle === "Transcript" ? "10px" : "0",
            }}
          >
            {firstPatientPanelTitle || ""}
          </p>
        </motion.div>
      )}
      <motion.div
        animate={
          togglePatientPanelOne ? { y: 30, opacity: 0 } : { y: 0, opacity: 1 }
        }
        transition={{
          duration: 0.4,
          delay: !togglePatientPanelOne && 0.6,
        }}
        style={{ height: "100%" }}
      >
        {!togglePatientPanelOne && (
          <>
            <div className="panel-tabs-row">
              <Tabs value={value} onChange={handleChange} aria-label="Tabs">
                <Tab
                  label={<span className="tabs_text">Patient Profile</span>}
                />
                <Tab label={<span className="tabs_text">Transcript</span>} />
              </Tabs>
              <button
                type="button"
                className="panel-collapse-btn"
                title="Collapse patient panel"
                aria-label="Collapse patient panel"
                data-testid="patient-panel-collapse"
                onClick={handleCollapse}
              >
                <LuChevronLeft
                  size={18}
                  color={darkMode ? "#fff" : "#0a0a0a"}
                />
              </button>
            </div>

            <div className="content">
              {value === 0 && <PatientProfile />}
              {value === 1 && <PatientTranscript />}
            </div>
          </>
        )}
      </motion.div>
    </motion.div>
  );
}
